<template>
    <v-container fluid style="background: #eaedf1">
        <v-sheet class="pa-3">
            <v-toolbar flat height="80">
                <v-btn
                    color="secondary"
                    class="text-capitalize px-5"
                    depressed
                    v-text="translations.createNewEmailTheme[lang]"
                    @click="openCreateUpdateEmailTheme('create')"
                ></v-btn>

                <v-spacer></v-spacer>

                <v-col cols="12" sm="4" class="pt-3">
                    <b-search-field v-model="search"></b-search-field>
                </v-col>
            </v-toolbar>
            
            <v-data-table
                :headers="headers"
                :loading="loading"
                :items="emailThemes"
                :footer-props="{
                    itemsPerPageOptions: [12],
                    showCurrentPage: true,
                    pageText: `${page * 12 - 11}-${
                        page * 12 <= serverItemsLength
                            ? page * 12
                            : serverItemsLength
                    } ${translations.paginationText[lang]} ${serverItemsLength}`
                }"
                :page.sync="page"
                :server-items-length="serverItemsLength"
                class="b-outlined rounded-0"
            >
                <template v-slot:item.thumbnail="{ item }">
                    <v-img
                        :src="item.thumbnail"
                        alt="icon"
                        class="ma-2"
                        width="350px"
                    ></v-img>
                </template>

                <template v-slot:item.actions="{ item }">
                    <v-tooltip color="secondary" top>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                icon
                                v-on="on"
                                @click="
                                    openCreateUpdateEmailTheme('update', item)
                                "
                            >
                                <v-icon
                                    v-text="icons.mdiPencilOutline"
                                ></v-icon>
                            </v-btn>
                        </template>

                        <span
                            class="font-weight-bold"
                            v-text="translations.edit[lang]"
                        ></span>
                    </v-tooltip>
                    <v-tooltip color="secondary" top>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                color="red"
                                icon
                                v-on="on"
                                @click="
                                    () => {
                                        removingEmailTheme = item;
                                        deleteDialog = true;
                                    }
                                "
                            >
                                <v-icon v-text="icons.mdiClose"></v-icon>
                            </v-btn>
                        </template>

                        <span
                            class="font-weight-bold"
                            v-text="translations.delete[lang]"
                        ></span>
                    </v-tooltip>
                </template>
            </v-data-table>
        </v-sheet>
        <v-dialog v-model="deleteDialog" max-width="500">
            <b-card
                type="delete"
                :title="translations.deleteEmailTheme[lang]"
                :submit-text="translations.delete"
                :loading="loading"
                :error-message="errorMessage"
                @cancel="deleteDialog = false"
                @submit="deletingEmailTheme(removingEmailTheme)"
            >
                <div class="subtitle-1 font-weight-medium pt-2 px-2">
                    {{ translations.deleteConfirmationMessage[lang] }}
                    <span class="font-weight-bold text--primary">{{
                        removingEmailTheme.title
                    }}</span
                    >{{ translations.questionmark[lang] }}
                </div>
            </b-card>
        </v-dialog>

        <v-dialog v-model="createUpdateDialog" max-width="1200">
            <b-card
                :submit-text="createUpdateDialogMode == 'update'?translations.update:translations.save"
                :submitBtn2="createUpdateDialogMode == 'update'"
                :submit-text2="translations.saveAsNew"
                :loading="loading || !themeIsReady"
                :disabled="!themeIsReady"
                :error-message="errorMessage"
                class="pa-0 full-card"
                @cancel="createUpdateDialog = false"
                @submit="submitTheme(createUpdateDialogMode)"
                @submit2="submitTheme('create')"
            >
                <v-row class=" pa-0 ma-0" style="border: none !important;">
                    <v-col
                        cols="12"
                        md="12"
                        style=""
                        class="pb-0 mb-0 header-field-container pl-8"
                    >
                        <b-mentionable v-if="createUpdateDialog" :mentionable-items="mentionableItems">
                            <b-text-field
                                :class="['header-field']"
                                v-model="emailTheme.title"
                                :label="translations.title[lang]"
                            />
                        </b-mentionable>

                    </v-col>
                    <v-col v-if="renderComponent" cols="12" md="12" class="pa-0 ma-0">
                        <b-email-editor 
                            @update="updateMailData"
                            :design="theme"
                        />
                    </v-col>
                </v-row>
            
                <v-expansion-panels
                    focusable
                    accordion
                    flat
                    hover
                    popout
                    tile
                    :disabled="!true"
                    v-model="testPanel"
                    class="test-panel transition-all"
                >
                    <v-expansion-panel>
                        <v-expansion-panel-header
                            ripple
                            class="pt-2 pb-2 rounded"
                        >
                            Test
                            <template v-slot:actions>
                                <v-icon color="secondary">
                                    $expand
                                </v-icon>
                            </template>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <b-card
                                hide-title
                                hide-default-footer
                                :cancel-btn="false"
                                elevation="0"
                                :submit-text="{
                                    el: 'Αποστολή',
                                    en: 'Send',
                                    it: 'Invia'
                                }"
                                @cancel="testDialog = false"
                            >
                                <div
                                    class="subtitle-1 font-weight-medium py-3"
                                    style="min-width: 250px; margin-left: -16px;"
                                >
                                    <b-text-field
                                        v-model="testContact.mail"
                                        :label="'Email'"
                                        no-margin-top
                                    ></b-text-field>
                                </div>

                                <v-card-actions class="d-flex justify-center">
                                    <v-btn
                                        type="submit"
                                        color="secondary"
                                        class="text-capitalize px-5"
                                        style="font-size: 0.9rem"
                                        depressed
                                        @click="
                                            submitTestMessage({
                                                ['mail']: testMail,
                                                ['email_address']:
                                                    testContact.mail,
                                                type: 'mail'
                                            });
                                            testDialog = false;
                                        "
                                        :loading="loading"
                                        >{{
                                            {
                                                el: "Αποστολή",
                                                en: "Send",
                                                it: "Invia"
                                            }[lang]
                                        }}
                                    </v-btn>
                                </v-card-actions>
                            </b-card>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </b-card>
        </v-dialog>
    </v-container>
</template>

<script>
import {
    mdiClose,
    mdiPencilOutline,
} from "@mdi/js";
import { mapMutations, mapState, mapActions } from "vuex";

import translations from "@/utils/translations/loyaltyPanel/campaigns/emailThemes";
import { sleepUntil } from "@/utils/helpers";
import debounce from "lodash/debounce";
import { cloneDeep } from "lodash";

export default {
    name: "ViewEmailThemes",

    mixins: [translations],

    // components: {
    //     Icon
    // },

    data() {
        return {
            icons: {
                mdiClose,
                mdiPencilOutline,
            },
            itemsPerPageOptions: [10, 20, 30, -1],
            page: +this.$route.query.page,
            removingEmailTheme: {},
            additionalDialog: false,
            search: +this.$route.query.q || "",
            deleteDialog: false,
            createUpdateDialog: false,
            createUpdateDialogMode: "update",
            emailTheme: {},
            emailBody: '',
            imageData: {
                error: "",
                success: false,
                image: null,
                url: "",
                image_file: null
            },
            errorMessages: {
                imageInvalid: {
                    el: "Μη έγκυρη εικόνα",
                    en: "Invalid image",
                    it: "Immagine non valido"
                },
                imageFailed: {
                    el: "Αποτυχία μεταφόρτωσης εικόνας",
                    en: "Failed to upload image",
                    it: "Impossibile caricare l'immagine"
                }
            },
            testPanel: null,
            testContact: {
                mail: ""
            },
            thumbnail: null,
            renderComponent: true,
            themeIsReady: false
        };
    },

    computed: {
        ...mapState([
            "loading",
            "errorMessage",
            "serverItemsLength",
        ]),
        ...mapState("loyaltyPanel/campaigns/emailThemes", [
            "emailThemes",
            "systemNotifications",
            "theme",
        ]),
        ...mapState("loyaltyPanel/campaigns/newCampaign", [
            "notificationVariables"
        ]),

        lang() {
            return this.$route.params.lang;
        },

        mentionableItems() {
            return this.notificationVariables.map(e => ({
                value: e,
                label: this.translations[e]?.lang || e
            }));
        },

        headers() {
            let headers = [
                {
                    text: this.translations.thumbnail[this.lang],
                    value: "thumbnail",
                    width: 450,
                },
                {
                    text: this.translations.title[this.lang],
                    value: `title`
                    // width: 250
                },
                {
                    text: this.translations.actions[this.lang],
                    value: "actions",
                    width: 250
                }
            ];
            return headers;
        },

        query() {
            let query = "?";
            for (let key in this.$route.query) {
                if (this.$route.query[key]) {
                    query += `${key}=${this.$route.query[key]}&`;
                }
            }
            return query.slice(0, query.length - 1);
        },

        testMail() {
            return {
                subject: this.emailTheme.title,
                body: this.emailBody 
            }
        }
    },

    watch: {
        $route(val) {
            if (!val.query.page) {
                this.$router.replace({
                    query: {
                        page: 1,
                        ...this.$route.query
                    }
                });
            }
            this.getEmailThemes({
                query: this.query,
            });
        },

        page(page) {
            this.$router.push({ query: { ...this.$route.query, page } });
        },

        search(val) {
            if (val == null) {
                this.$route.query.q = undefined;
                this.getEmailThemes({
                    query: this.query,
                });
            } else {
                this.debouncedSearch();
            }
        },

        ["emailTheme.thumbnail"](val) {
            if (val) {
                this.imageData.url = val;
            }
        },
        actionToRun(val){
            if (val && typeof val == 'function') {
               if (this.dataUpdated) {
                 //todo
               }
                
            }
        }
    },

    methods: {
        ...mapActions("loyaltyPanel/campaigns/emailThemes", [
            "getEmailThemes",
            "deleteTheme",
            "updateTheme",
            "createTheme",
            "uploadThumbnail"
        ]),
        ...mapActions("loyaltyPanel/campaigns/newCampaign", [
            "getNotificationVariables",
            "sendTestMessage"
        ]),

        ...mapMutations(["setNotification", "setLoading"]),
        ...mapMutations("loyaltyPanel/campaigns/emailThemes", [
            "setTheme",
        ]),

        filterChannels(ids) {
            return this.systemNotifications.filter(e =>
                ids.includes(e.system_notification_id)
            );
        },

        async updateMailData(val) {
            this.themeIsReady = false
                if (val?.design) {
                    this.emailTheme.theme = val.design
                }
                if (val?.html) {
                    this.emailBody = val.html
                }
                this.emailThumbnail = val.thumbnail || null
                this.themeIsReady = val.isReady

        },
        async forceRerender() {
            this.renderComponent = false;
            await this.$nextTick();
            this.renderComponent = true;
        },
        async submitTestMessage(payload) {
            let res = await this.sendTestMessage(payload);
            if (res && res.data && !res.data.error) {
                this.setNotification({
                    show: true,
                    type: "success",
                    text: this.translations.testSent[this.lang]
                });
            } else {
                this.setNotification({
                    show: true,
                    type: "error",
                    text: this.translations.testFailed[this.lang]
                });
            }
        },
        handleSearch() {
            if (this.page != 1) {
                this.page = 1;
            } else {
                this.$router.push({
                    query: { ...this.$route.query, q: this.search }
                });
            }
        },

        openCreateUpdateEmailTheme(mode, emailTheme = { theme: null}) {
            this.emailTheme = { theme: null }
            if (emailTheme?.store_email_theme_id) {
                this.emailTheme = cloneDeep(emailTheme);
            }
            this.setTheme(emailTheme.theme)

            this.$nextTick(() => {
                this.createUpdateDialogMode = mode;
                this.createUpdateDialog = true;
            });

        },

        async getThumbnail(){
                if (this.emailThumbnail?.blob) {
                    let thumbnailResponse = await this.uploadThumbnail ({image: this.emailThumbnail?.blob})
                    this.emailTheme.thumbnail = thumbnailResponse?.url || '';
                }else { 
                    this.emailTheme.thumbnail =  '' 
                }
        },

        async submitTheme(action) {
            try {
                this.setLoading(true)
            await this.$nextTick(async () => {
                await sleepUntil(() => (this.themeIsReady), 300000 );
                    await this.$nextTick(async () => {

                        await this.getThumbnail()
                        let res = await this[`${action}Theme`](this.emailTheme);
                        if (res.code == 200) {
                            this.createUpdateDialog = false;
                            this.createUpdateDialogMode = "";
                            this.setTheme(null)
                            this.forceRerender()  
                        }
            });
                this.setLoading(false)
            }); 
            } catch (error) {
                console.log('submit theme error: ' + error)
            }
        },

        deletingEmailTheme(emailTheme) {
            this.$nextTick(async () => {
                if (this.deleteTheme(emailTheme)) {
                    this.deleteDialog = false;
                }
            });
        },

    },

    mounted() {
        this.getNotificationVariables();
        this.getEmailThemes({
            query: this.query
        });
    },

    created() {
        this.debouncedSearch = debounce(this.handleSearch, 500);
        this.search = this.$route.query.q || "";
    },

    beforeCreate() {
        if (!this.$route.query.page) {
            this.$router.replace({
                query: {
                    page: 1,
                    ...this.$route.query
                }
            });
        }
    }
};
</script>

<style>
.b-outlined {
    border: 1px solid rgba(0, 0, 0, 0.12);
}

.header-field-container {
    position: absolute;
    top: 0;
    padding-top: 0;
    left: 60px;
    overflow: hidden;
    max-width: 1050px;
}
.header-field {
    padding-right: 0 !important;
}
.has-error .error--text {
    background: white !important;
    padding-left: 5px;
    padding-bottom: 3px;
    border-radius: 4px;
}
.full-card {
    margin: 0 !important;
    padding: 0 !important;
}
.full-card .v-card__text {
    margin: 0 !important;
    padding: 0 !important;
}
.test-panel {
    max-width: 280px;
    position: absolute;
    bottom: 6px;
    left: 6px;
}
.test-panel .v-expansion-panel-header {
    min-height: 38px;
}
</style>
